import { Component, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { TranslocoDirective } from '@jsverse/transloco';
import { SessionStoreRepository } from '../../repositories/session.repository';
import { HasFogPService } from '../../store/hasFogpStore';
import { environment } from '../../../../environments/environment';
import { HelperComponent } from "../helper/helper.component";

@Component({
    selector: 'web-patient-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    imports: [CommonModule, RouterLink, TranslocoDirective, HelperComponent, NgOptimizedImage]
})
export class HeaderComponent {
    private readonly sessionService = inject(SessionStoreRepository)
    private readonly router = inject(Router);
    private readonly fogpService = inject(HasFogPService);

    public readonly username$: Observable<string> = this.sessionService.userNameInit$;
    public readonly isLoggedIn$: Observable<boolean> = this.sessionService.isLoggedIn$;
    public readonly isPatient$: Observable<boolean> = this.sessionService.isPatient$;
    public readonly hasFogpForms$: Observable<boolean | undefined> = this.fogpService.hasForms$
    public readonly fogpRedirectUrl: string = environment.fogpRedirectUrl;

    onLogoutClick(): void {
        this.router.navigate(["/auth/logout"]);
    }

    onLoginClick(): void {
        this.router.navigate(["/auth/login"]);
    }

    onTitleClick(): void {
        if (!this.sessionService.isLoggedIn()) {
            this.router.navigate(["/welcome"]);
        } else {
            this.router.navigate(["/authenticated"]);
        }
    }

    navigateToUserPage(): void {
        this.isPatient$.subscribe({
            next: value => {
                if (value) {
                    this.router.navigate(["/profile"]);
                } else {
                    this.router.navigate(["/clinic"]);
                }
            }
        })
    }
}
